// Constants
import { ApplicationPlatform } from './platformTypes';

export const isApplicationPlatformMobile = (platform: ApplicationPlatform) =>
    [
        ApplicationPlatform.IPHONE_DEPRECATED,
        ApplicationPlatform.iphoneApp,
        ApplicationPlatform.iphoneWeb,
        ApplicationPlatform.iphonePwa,

        ApplicationPlatform.ANDROID_DEPRECATED,
        ApplicationPlatform.androidPhoneApp,
        ApplicationPlatform.androidPhoneWeb,
        ApplicationPlatform.androidPhonePwa,
    ].includes(platform);

export const isApplicationPlatformIosApp = (platform: ApplicationPlatform) =>
    [ApplicationPlatform.iphoneApp, ApplicationPlatform.ipadApp].includes(platform);

export const isApplicationPlatformAndroidApp = (platform: ApplicationPlatform) =>
    [ApplicationPlatform.androidPhoneApp, ApplicationPlatform.androidTabletApp].includes(platform);
